import {EMPTY_SIDEBAR_FILTERS} from './helpdeskTicketsUtils';

const readJson = (value, fallback) => {
  try {
    return JSON.parse(value) ?? fallback;
  } catch {
    return fallback;
  }
};

/** Queue state belongs to the history entry, so Back and refresh restore it. */
export const readTicketQueueState = search => {
  const params = new URLSearchParams(search);
  const savedFilters = readJson(params.get('filters'), {});
  const filters = {...EMPTY_SIDEBAR_FILTERS};
  Object.keys(filters).forEach(key => {
    const value = savedFilters?.[key];
    if (Array.isArray(filters[key])) {
      filters[key] = Array.isArray(value)
        ? value.filter(item => typeof item === 'string')
        : [];
    } else if (key === 'unrated') {
      filters[key] = value === true;
    } else if (key.endsWith('Min') || key.endsWith('Max')) {
      filters[key] =
        typeof value === 'number' && Number.isFinite(value) ? value : undefined;
    } else if (typeof value === 'string') filters[key] = value;
  });
  const users = readJson(params.get('users'), []);
  const page = Number(params.get('page'));
  const pageSize = Number(params.get('pageSize'));
  return {
    search: params.get('q') || '',
    viewMode: ['list', 'chat'].includes(params.get('view'))
      ? params.get('view')
      : 'grid',
    page: Number.isInteger(page) && page > 0 ? Math.min(page, 100000) : 1,
    pageSize: [12, 24, 48].includes(pageSize) ? pageSize : 12,
    filters,
    selectedUsers: Array.isArray(users)
      ? users.filter(user => typeof user === 'string')
      : [],
  };
};

export const writeTicketQueueState = state => {
  const params = new URLSearchParams();
  if (state.search) params.set('q', state.search);
  if (state.viewMode !== 'grid') params.set('view', state.viewMode);
  if (state.page > 1) params.set('page', state.page);
  if (state.pageSize !== 12) params.set('pageSize', state.pageSize);
  const filters = {};
  Object.keys(EMPTY_SIDEBAR_FILTERS).forEach(key => {
    const value = state.filters[key];
    if (
      Array.isArray(value)
        ? value.length
        : value !== undefined &&
          value !== null &&
          value !== false &&
          value !== ''
    )
      filters[key] = value;
  });
  if (Object.keys(filters).length)
    params.set('filters', JSON.stringify(filters));
  if (state.selectedUsers.length)
    params.set('users', JSON.stringify(state.selectedUsers));
  const search = params.toString();
  return search ? `?${search}` : '';
};

export const supportTicketReturnTo = location => {
  const target = location.state?.ticketReturnTo;
  // Only return to an internal dashboard page supplied by the opening screen.
  return typeof target === 'string' && target.startsWith('/dashboard/')
    ? target
    : '/dashboard/ai-helpdesk';
};
